import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonSettings, CreditCardService, ErrorHandlerService } from 'epay-library';

@Component({
  selector: 'epay-creditcard-success',
  templateUrl: './creditcard-success.component.html'
})
export class CreditCardSuccessComponent implements OnInit {
  pagetitle = "Credit Card Payment Success";
  encryptedTransactionId: string;
  baseurl = CommonSettings.BaseApi;
  clientId = CommonSettings.ClientID;

  paymentDate = '';
  empName = '';
  name = '';
  referenceID = '';
  confirmationId = '';
  amount = 0;
  processFee = 0;
  totalAmount = 0;
  transactionId = '';
  payorType = '';

  errorMessage = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private creditcardservice: CreditCardService,
    private errorhandleservice: ErrorHandlerService,
    private datePipe: DatePipe
  ) {
    this.encryptedTransactionId = '';
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.encryptedTransactionId = params['tid'];
    });

    this.creditcardservice
      .getCreditCardAttemptLogDetails(
        this.baseurl,
        this.encryptedTransactionId,
        this.clientId
      )
      .subscribe({
        next: (response: any) => {
          console.log("CC RESPONSE")
          this.name = response[0].fullName;
          this.referenceID = response[0].referenceId;
          this.paymentDate = response[0].logEntryTime;
          this.empName = response[0].employerName;
          this.confirmationId = response[0].confirmationNumber;
          this.amount = +response[0].paymentAmount;
          this.processFee = +response[0].convenienceAmount;
          this.totalAmount = +response[0].totalPaymentAmount;
          this.transactionId = response[0].transactionNumber;
          this.payorType = response[0].payorType;
        },
        error: (error: any) => {
          console.log(error);
          this.logError(error);
          this.handleError(error.staus);
        },
      });

      this.paymentDate = "2025-01-22T21:20:40.16Z"
  }

  Print() {
    window.print();
  }

  GoToHomePage() {
    this.router.navigateByUrl('home');
  }

  logError(error: Error) {
    this.errorhandleservice.logError(error);
  }

  handleError(error: number) {
    console.log(this.errorMessage);
    this.errorhandleservice.handleErrorMessage(error, this.baseurl);
  }
}

